import {
  ALARM_LIMITS_SEARCH_CONTAINER,
  ALL_MONLOG_SEARCH_CONTAINER,
  ALL_OPLOG_SEARCH_CONTAINER,
  AREAS_CONTAINER,
  CLAIM_ROLE_ASSIGN_CONTAINER,
  COMMERCIAL_CONTACT_SEARCH_CONTAINER,
  COMPANY_CONTAINER,
  CONTACT_LIST_SEARCH_CONTAINER,
  CONTACT_SEARCH_CONTAINER,
  CONTROLLER_NOTES,
  CRM_ST_SEARCH_CONTAINER,
  DAILY_OPERATING_PLANS,
  EMAIL_CONTAINER,
  EXTERNAL_LIST_SEARCH_CONTAINER,
  FACILITY_SEARCH_CONTAINER,
  FIELD_VISION,
  GIS_MAP_EMBED,
  JOB_ROLES_CONTAINER,
  LOCATION_CONTAINER,
  MC_ST_SEARCH_CONTAINER,
  MOBILE_CONTROLLER_NOTES_SEARCH_CONTAINER,
  MOBILE_MONLOG_SEARCH_CONTAINER,
  MOC_EVENT_CATEGORIES_CONTAINER,
  MOC_EVENT_SEARCH_CONTAINER,
  MON_LOG_TYPES_CONTAINER,
  MONLOG_SEARCH_CONTAINER,
  MUSTER_LIST_SEARCH_CONTAINER,
  MY_PROFILE_CONTAINER,
  NOTE_TYPES_CONTAINER,
  PARTS_SEARCH_CONTAINER,
  REGIONS_CONTAINER,
  ROLE_BUSINESS_UNIT_ASSIGN_CONTAINER,
  ROLE_CLAIM_ASSIGN_CONTAINER,
  SAP_OUTAGE_REPORT_CONTAINER,
  STATION_LOGS_CONTAINER,
  TROUBLESHOOTING_SEARCH_CONTAINER,
} from 'src/app/constants/common.constants';

export type MenuRoute = keyof typeof menuContainerMapping;
export type MenuContainer = (typeof menuContainerMapping)[MenuRoute];

export const menuContainerMapping = {
  '/monLogs/logs': MONLOG_SEARCH_CONTAINER,
  '/monLogs/logs/all': ALL_MONLOG_SEARCH_CONTAINER,
  '/monLogs/turnovers': MC_ST_SEARCH_CONTAINER,
  '/monLogs/logs/search': MOBILE_MONLOG_SEARCH_CONTAINER,
  '/locations/facility': FACILITY_SEARCH_CONTAINER,
  '/locations/location': LOCATION_CONTAINER,
  '/locations/area': AREAS_CONTAINER,
  '/locations/region': REGIONS_CONTAINER,
  '/contacts/me': MY_PROFILE_CONTAINER,
  '/contacts/contact': CONTACT_SEARCH_CONTAINER,
  '/contacts/contactList': CONTACT_LIST_SEARCH_CONTAINER,
  '/contacts/contactList/external': EXTERNAL_LIST_SEARCH_CONTAINER,
  '/crm/controllerNotes': CONTROLLER_NOTES,
  '/crm/dailyOperatingPlans': DAILY_OPERATING_PLANS,
  '/crm/turnovers': CRM_ST_SEARCH_CONTAINER,
  '/crm/mocEvents': MOC_EVENT_SEARCH_CONTAINER,
  '/controlRoom/controllerNotes/search':
    MOBILE_CONTROLLER_NOTES_SEARCH_CONTAINER,
  '/opLogs/logs/all': ALL_OPLOG_SEARCH_CONTAINER,
  '/operational-monitoring/alarm-limits': ALARM_LIMITS_SEARCH_CONTAINER,
  '/operational-monitoring/station-logs': STATION_LOGS_CONTAINER,
  '/operational-monitoring/partsSearch': PARTS_SEARCH_CONTAINER,
  '/operational-monitoring/troubleshooting': TROUBLESHOOTING_SEARCH_CONTAINER,
  '/operational-monitoring/muster-list': MUSTER_LIST_SEARCH_CONTAINER,
  '/maps/gisMapEmbed': GIS_MAP_EMBED,
  '/maps/fieldVision': FIELD_VISION,
  '/reporting/sapOutage': SAP_OUTAGE_REPORT_CONTAINER,
  '/admin/emailGroups': EMAIL_CONTAINER,
  '/admin/claimAssignment': ROLE_CLAIM_ASSIGN_CONTAINER,
  '/admin/roleAssignment': CLAIM_ROLE_ASSIGN_CONTAINER,
  '/admin/businessUnitAssignment': ROLE_BUSINESS_UNIT_ASSIGN_CONTAINER,
  '/admin/manageData/monLogTypes': MON_LOG_TYPES_CONTAINER,
  '/admin/manageData/jobRoles': JOB_ROLES_CONTAINER,
  '/admin/manageData/companies': COMPANY_CONTAINER,
  '/admin/manageData/mocEventCategories': MOC_EVENT_CATEGORIES_CONTAINER,
  '/admin/manageData/noteTypes': NOTE_TYPES_CONTAINER,
  '/commercialServices/commercialContacts': COMMERCIAL_CONTACT_SEARCH_CONTAINER,
} as const;
